import apiClient from '@/services/rest-api-tools/apiClient'

const baseEndpoint = '/sensor'

export const get = async (queryParam) => {
  const params = {
    includes: queryParam?.includes || undefined,
    page: queryParam?.page || undefined,
    size: queryParam?.size || undefined,
    filters: queryParam?.filters || undefined,
  }
  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}`,
    params: params,
  })

  return response?.data
}
